import { InjectionToken } from "@angular/core";
import { IGroupRestClient } from "./i-group-rest.client";

export const groupRestClientInjectionToken: InjectionToken<IGroupRestClient> = new InjectionToken<IGroupRestClient>("digital-signage.user-dashboard.dashboard-web.GroupRestClient");
